export const DEFAULT_VERSION_TYPE_SETTING = 'default_version_view_type';
